import React from "react";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector, useDispatch } from "react-redux";
import { updateFiguritas } from "../../actions/figuritasActions";
import { updateAlbumCollection } from "../../firebase/firestore";

export default function AutorizadosPill({ autorizado }) {
  const figuritas = useSelector((state) => state.figuritasReducer.figuritas);
  const dispatch = useDispatch();

  const deleteAutorizado = () => {
    const autorizados = [
      ...figuritas.autorizados.filter(
        (object) => object.email !== autorizado.email
      ),
    ];

    const figuritasUpdated = { ...figuritas, autorizados };

    dispatch(updateFiguritas(figuritasUpdated));
    updateAlbumCollection(figuritas.owner, figuritasUpdated);
  };

  return (
    <div className="autorizadoPill">
      <div>{autorizado.email}</div>
      <div className="deleteIconAutorizado">
        <FontAwesomeIcon icon={faCircleXmark} onClick={deleteAutorizado} />
      </div>
    </div>
  );
}
